import { z } from 'zod';
export const ProfileAvatarSource = z.enum(['initials', 'image']);
export const ProfileAvatarDesign = z.object({
    source: ProfileAvatarSource,
    initials: z.string().trim().min(1).max(4).nullable(),
    imageFileId: z.string().uuid().nullable(),
    imageUrl: z.string().nullable(),
    accent: z.enum(['iris', 'jade', 'amber', 'rose', 'slate', 'sky', 'coral']),
    shape: z.enum(['circle', 'rounded']),
    style: z.enum(['solid', 'soft', 'ring']),
    fit: z.enum(['cover', 'contain']),
    frame: z.enum(['clean', 'shadow', 'halo']),
    backdrop: z.enum(['solid', 'gradient', 'linen']),
    scale: z.number().int().min(80).max(180),
    positionX: z.number().int().min(0).max(100),
    positionY: z.number().int().min(0).max(100),
});
export const ProfileAvatarUpdate = ProfileAvatarDesign.omit({ imageUrl: true }).partial();
//# sourceMappingURL=avatar.js.map